<template>
  <div v-if="currentUser" class="col-10 offset-1 col-md-6 offset-md-3">
    <form @submit.prevent="validateInformation" class="p-t-15" role="form" novalidate="novalidate">
      <common-validation-form :currentUser="currentUser" />

      <profession-form
          :dataUser="dataUser"
          :isManager="false"
          :currentUser="currentUser"
          :isSingleEntity="true"
          :small="true"
          :availableServices="servicesOptions"
          :availableHubs="hubsOptions"
          :availableOccupations="occupationsOptions"
          @change="onChange($event)"
        />
      
      <terms-and-conditions :currentUser="currentUser" :currentEntity="dataUser.entity" />
      
      <div class="col-md-12 validate-button">
        <button class="btn btn-primary btn-cons m-t-10" type="submit">
          {{ $t("form.update_information.button") }}
        </button>
      </div>
    </form>
  </div>
</template>

<script>
  import {mapGetters} from 'vuex'
  import { formatNumber, parseNumber } from 'libphonenumber-js'
  import ie_mixin from '@/mixin/ie'
  import CommonValidationForm from './CommonValidationForm'
  import ProfessionForm from './ProfessionForm';
  import TermsAndConditions from './TermsAndConditions.vue';

  export default {
    name: "ValidationForm",
    mixins: [ie_mixin],
    props: ['currentUser'],
    components: { CommonValidationForm, ProfessionForm, TermsAndConditions },
    data() {
      return {
        dataUser: Object.assign({}, this.currentUser.user_entities[0])
      }
    },
    computed: {
      ...mapGetters({
        serverErrors: 'users/errors',
        hasErrors: 'users/hasErrors',
        hubsOptions: 'users/allHubs',
        servicesOptions: 'users/allServices',
        occupationsOptions: 'users/manageableOccupations'
      })
    },
    methods: {
      onChange(value) {
        this.dataUser = value
      },
      validateInformation() {
        this.$validator.validateAll().then((result) => {
          if (result && !this.hasErrors) {
            this.currentUser.phone = formatNumber(parseNumber(this.currentUser.phone_display, 'FR'), 'E.164')
            let user = this.currentUser
            user.add_ons = [this.dataUser]
            this.$store.dispatch('users/updateProfile', user)
              .then(() => {
                this.$store.dispatch('auth/signOut');
                this.$router.replace({name: 'SignUpConfirmationPage'})
              }).catch((err) => { })
          }
        })
      }
    },
    mounted: async function () {
      this.dataUser = Object.assign({}, this.currentUser.user_entities[0])
      await this.$store.dispatch('users/initManageableOptions', { entityId: this.dataUser.entity.id })
    }
  }
</script>

<style scoped>
  .resource-type label.label_internal {
    text-transform: none;
  }

  .accept-cgu a {
    text-decoration: underline;
  }

  .validate-button {
    text-align: center;
    margin-bottom: 20px;
  }
</style>



// WEBPACK FOOTER //
// src/components/candidate/ValidationForm.vue